/**
 * MilestoneProgressBar Component
 *
 * Horizontal segmented progress bar showing all milestones
 * with color-coded segments proportional to weight_percentage.
 *
 * @module components/milestones/MilestoneProgressBar
 */

import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const statusColors = {
  pending: '#6c757d',
  in_progress: '#0d6efd',
  completed: '#198754',
  cancelled: '#dc3545',
};

const MilestoneProgressBar = ({ milestones = [] }) => {
  if (!milestones.length) return null;

  const totalWeight = milestones.reduce((sum, m) => sum + (m.weight_percentage || 0), 0);

  return (
    <div className="d-flex w-100 rounded overflow-hidden" style={{ height: '24px', background: '#e9ecef' }}>
      {milestones.map((milestone) => {
        const widthPct = totalWeight > 0
          ? ((milestone.weight_percentage || 0) / totalWeight) * 100
          : 100 / milestones.length;

        return (
          <OverlayTrigger
            key={milestone.id}
            placement="top"
            overlay={
              <Tooltip>
                {milestone.title} ({milestone.weight_percentage || 0}%)
                <br />
                Estado: {milestone.status}
              </Tooltip>
            }
          >
            <div
              style={{
                width: `${widthPct}%`,
                backgroundColor: statusColors[milestone.status] || '#6c757d',
                transition: 'width 0.3s ease',
                cursor: 'pointer',
                borderRight: milestones.length > 1 ? '1px solid rgba(255,255,255,0.3)' : 'none',
              }}
            />
          </OverlayTrigger>
        );
      })}
    </div>
  );
};

export default MilestoneProgressBar;
